import * as React from 'react';
export const RWSvg = React.forwardRef(function RWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M1.994 0A1.998 1.998 0 0 0 0 1.998V6h16V1.998A1.997 1.997 0 0 0 14.006 0H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 6h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 9V6h1v3h-1ZM0 6h1v3H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 9v1.5c0 .828.667 1.5 1.505 1.5h12.99A1.5 1.5 0 0 0 16 10.5V9H0Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 13,
        cy: 3,
        r: 1,
        fill: '#FCD669',
      }),
    ),
  );
});
RWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var RW = {
  category: 'flag',
  colorable: false,
  name: 'RW',
  svg: RWSvg,
};
